import { PERMISSIONS, ROUTE_PATHS } from "../../../PermissionsConstants";
import CAMSReports from "./CAMSReports";
import { CDRCExceptionReport } from "./CDRCExceptionReport";
import { SnowflakeReport } from "./SnowflakeReport";
import { AL3Report } from "./AL3Report";
import { KeeperExceptionReport } from "./KeeperExceptionReport";

export const ProducerCodeSideBar = [
  {
    title: "Carrier State Office Codes",
    to: ROUTE_PATHS.CSOPC_Reports_Index,
    component: CAMSReports,
    permission: PERMISSIONS.permission_report_carrierstatesofficecode_view,
  },
  {
    title: "CDRC Exception Report",
    to: ROUTE_PATHS.MappedToCDRC_Reports,
    component: CDRCExceptionReport,
    permission: PERMISSIONS.permission_report_cdrcexception_view,
  },
  {
    title: "Tableau - All Data Report",
    to: ROUTE_PATHS.Snowflake_Reports,
    component: SnowflakeReport,
    permission: PERMISSIONS.permission_report_allsnowflakes_view,
  },
  {
    title: "AL3 Exception Data Report",
    to: ROUTE_PATHS.AL3_Reports,
    component: AL3Report,
    permission: PERMISSIONS.permission_report_allal3_view,
  },
  {
    title: "Keeper Exception Report",
    to: ROUTE_PATHS.MappedToKeeper_Reports,
    component: KeeperExceptionReport,
    permission: PERMISSIONS.permission_report_keeperexception_view,
  },
];
